module.exports = "https://cdn.printos.com/fonts/font-awesome/4.6.3/fontawesome-webfont.eot";


// WEBPACK FOOTER //
// ../~/file-loader?publicPath=https:/cdn.printos.com/fonts/font-awesome/4.6.3/&name=[name].[ext]&emitFile=false!../~/font-awesome/fonts/fontawesome-webfont.eot